import { validation } from "./validation";
import { TextInput } from "../TextInput";
import "./styles.css";

const FreeText = ({ getInputTextDiv }) => {
  return <>{getInputTextDiv()}</>;
};

export default TextInput(FreeText, {
  validation,
});
